import React from 'react'
import PropTypes from 'prop-types'
import IconClose from '../../../globals/images/icon-close.svg'
const Container = ( { onClose, onCloseButtonId='', children } ) => {
  return ( <main className="c-main">
      <div className="os-container--max-width">
          <div className="c-mfa-card">
              <div className="c-mfa-card__close-icon-container"> 
                  <div className='c-mfa-svg-close-container' ><img aria-label='Select X to close button' tabIndex='0' id={ onCloseButtonId } src={ IconClose } alt="Close" className='c-mfa-svg-close' onClick={ onClose } data-testid = 'close-icon'/></div>
                  <div className='child-container'>{ children }</div>                  
              </div>
          </div>
      </div>
  </main>
  )
}

Container.propTypes = {
    onClose: PropTypes.func,
    onCloseButtonId: PropTypes.string,
    children: PropTypes.node,
}

export default Container